import { LogLevel } from '../schema/log-level.enum';
import { API_URL } from '../constants/api.constants';
import { APP_CONFIG } from '../constants/app.constants';
import { TECHNICAL_SUPPORT_COLLECTION } from '../constants/collections.constants';
import { HOST } from '../constants/host.constants';
import { POSTHOG } from '../constants/posthog.constants';
import { WEBSITE_URL } from '../constants/website.constants';

import { EnvironmentType } from '../schema/environment.enum';
import { IEnvironment } from '../schema/environment.model';

export const createEnvironment = (
  env: EnvironmentType,
  overrides: Partial<IEnvironment> = {}
): IEnvironment => {
  const base: IEnvironment = {
    host: HOST[env],
    apiUrl: API_URL[env],
    websiteUrl: WEBSITE_URL[env],
    technicalSupportCollection: TECHNICAL_SUPPORT_COLLECTION[env],
    production: env === EnvironmentType.PRODUCTION || env === EnvironmentType.LIVE,
    logLevel:
      env === EnvironmentType.PRODUCTION
        ? LogLevel.ERROR
        : LogLevel.DEBUG,
    socketUrl: APP_CONFIG.SOCKET_URL,
    agoraAppId: APP_CONFIG.AGORA_APP_ID,
    useInMemoryClients: false,
    // PostHog: absent for LOCAL / IN_MEMORY / TEST / RE_DESIGN by design (see posthog.constants.ts).
    posthog: POSTHOG[env]
  };

  return {
    ...base,
    ...overrides // 🔥 allows customization per env
  };
};